import { FC, SVGProps } from 'react';

export const LeftArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 10.1111H17M6.11111 13.2222L3 10.1111L6.11111 13.2222ZM3 10.1111L6.11111 7L3 10.1111Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
